import React, { Fragment } from "react";
import { useEffect } from "react";
import ReactDom from "react-dom";
import './Modal.css'
import { getConfiguration } from "../utils";

const Backdrop = (props) => {
  return <div className={`modal__backdrop ${props.transparent ? 'modal__backdrop__transparent' : ''} `}></div>;
};

const ModalOverlay = (props) => {
  const avoidClose = props.uncloseable;
  const typeMessage = props.type || '';
  const conf = getConfiguration();
 
  return (

    conf.iwh ? <div className={`modal__overlay ${typeMessage} ${props.isMobile ? 'modal__overlay__mobile' : ''} `}>
     
      <div className={`modal__header ${typeMessage}`}>
        <div className={`modal__header__testo`}>{props.modalHeader}</div>
        {props.showGoBack &&
          <button onClick={props.onGoBack} className={`modal__header__bottoneIndietro`}></button>
        }
        {
          !avoidClose &&
          <button
            onClick={props.onClose}
            className={`modal__header__bottoneChiudi`}></button>
        }

      </div>
      <div className={`modal__content ${props.isMobile ? 'modal__content__mobile' : ''} `}>{props.children}</div>
    </div>

      :
      <div className={`modal__overlay ${props.isMobile ? 'modal__overlay__mobile' : ''} `}>
       
        <div className={`modal__header`}>
          <div className={`modal__header__testo`}>{props.modalHeader}</div>
          {props.showGoBack &&
            <button onClick={props.onGoBack} className={`modal__header__bottoneIndietro`}></button>
          }
          {
            !avoidClose &&
            <button
              onClick={props.onClose}
              className={`modal__header__bottoneChiudi`}></button>
          }

        </div>
        <div className={`modal__content ${props.isMobile ? 'modal__content__mobile' : ''} `}>{props.children}</div>
      </div>

  );
};

const Modal = (props) => {
  const portalElement = document.getElementById("modal__container");

  useEffect(() => {
    const body = document.body;

    if (props.isMobile) {
      if (body) {
        body.classList.add("xs-mobile-no-scroll")
      }
    }

    return () => {
      if (props.isMobile) {
        if (body) {
          body.classList.remove("xs-mobile-no-scroll")
        }
      }

    }

  }, [])

  return (
    <Fragment>
      {ReactDom.createPortal(
        <Backdrop onClose={props.onClose} transparent={props.transparentBackdrop} />,
        portalElement
      )}
      {ReactDom.createPortal(
        <ModalOverlay {...props} >{props.children}</ModalOverlay>,
        portalElement
      )}
    </Fragment>
  );
};

export default Modal;
